import Button from 'components/Button'
import ErrorMessage from 'components/ErrorMessage'
import Input from 'components/Input'
import Modal, { ModalFooter } from 'components/Modal'
import React, { useState } from 'react'
import UtilsService from 'services/UtilsService'
import useAuth from 'store/AuthContext'
import useProduct from 'store/SingleProductProvider'
import { ReportForm, OrderLabelWithInput } from './ReportModal.style'

const ReportModal = props => {
  const { open, ...rest } = props
  const [report, setReport] = useState('')
  const [, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const { user } = useAuth()
  const {
    product: { sku },
  } = useProduct()

  const changeReport = e => {
    setReport(e.target.value)
  }

  const sendReport = () => {
    setLoading(true)
    UtilsService.sendReport({
      sku: sku,
      report: report,
    })
      .then(data => {
        setReport('')
        setSuccess(true)
        setError(false)
        setLoading(false)
      })
      .catch(() => {
        setError(true)
        setLoading(false)
      })
  }

  return (
    <Modal show={open} hideClose={true} title="შეცდომის შეტყობინება" {...rest}>
      <ReportForm>
        <OrderLabelWithInput>
          <span>აღწერეთ შეცდომა:</span>
          <Input
            component="textarea"
            resize="false"
            onChange={changeReport}
            rows="10"
            value={report}
            defaultValue={user.name}
            placeholder="მაგ: არასწორი სახელი"
          />
          <ErrorMessage
            show={error}
            message="შეცდომა მონაცემების გაგზავნისას"
          />
          {success && <p className="success">გმადლობთ, წარმატებით დაემატა</p>}
        </OrderLabelWithInput>
      </ReportForm>
      <ModalFooter>
        <Button disabled={success} color="orange" onClick={sendReport}>
          გაგზავნა
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ReportModal
